import gql from 'graphql-tag';

export const NOTIFICATIONS = gql`
  query notifications {
    notifications {
      id
      type
      isRead
      createdAt
      ... on PointCloudConvertDoneNotification {
        organisationId
        meta {
          projectId
          projectName
          uploadStatus: status
        }
      }
      ... on PointCloudCalculationDoneNotification {
        organisationId
        meta {
          projectId
          projectName
          status
          annotationIdentifier
        }
      }
      ... on UserAcceptedInvitationNotification {
        organisationId
        meta {
          organisationName
          userName
        }
      }
      ... on PointCloudExportDoneNotification {
        organisationId
        meta {
          projectId
          projectName
          status
          thisExport {
            exportId
            type
            status
            createdAt
            paramInfo {
              ... on PointCloudExportParamInfo {
                fileType
                heightFilters
                classificationFilters
                resolutionFilter
                clippingFilter
              }
            }
          }
        }
      }
      ... on UserGotMentionedNotification {
        organisationId
        meta {
          projectId
          mentioningUserId
          mentioningUserName
          referenceObjectIdentifier
          commentId
        }
      }
      ... on CreditsPurchasedNotification {
        organisationId
        meta {
          organisationName
          userName
          amount
        }
        ledgerEntry {
          id
          odooInvoiceId
          odooInvoiceUrl
          odooInvoiceNumber
        }
      }
      ... on SubscriptionPurchasedNotification {
        organisationId
        meta {
          organisationName
          userName
          subscriptionType
          fromSubscriptionType
        }
        ledgerEntry {
          id
          odooInvoiceId
          odooInvoiceUrl
          odooInvoiceNumber
        }
      }
      ... on ProjectAwaitingCreditsNotification {
        organisationId
        meta {
          projectId
          projectName
          requiredCredits
        }
      }
      ... on ProjectCustomDealNotification {
        organisationId
        meta {
          projectId
          projectName
          organisationId
          pointCountTotal
        }
      }
      ... on SalesRequestNotification {
        organisationId
        meta {
          organisationName
          userName
          userEmail
          message
        }
      }
      ... on OrganisationInviteNotification {
        organisationId
        meta {
          organisationName
          invitedByName
          inviteToken
          # Aliased: other notification types select non-null projectId/projectName on their meta,
          # and GraphQL refuses overlapping fields whose types differ.
          inviteProjectId: projectId
          inviteProjectName: projectName
        }
      }
      ... on ProjectInviteNotification {
        organisationId
        meta {
          projectId
          projectName
          organisationName
          invitedByName
        }
      }
      ... on CustomerRenewalNotification {
        organisationId
        meta {
          customerOrganisationId
          customerName
          subscriptionType
          renewsAt
        }
      }
    }
  }
`;

export const NOTIFICATIONS_MARK_AS_READ = gql`
  mutation notificationsMarkAsRead($ids: [ID!]) {
    notificationsMarkAsRead(ids: $ids)
  }
`;

export const NOTIFICATIONS_DELETE = gql`
  mutation notificationsDelete($ids: [ID!]!) {
    notificationsDelete(ids: $ids)
  }
`;

export const NOTIFICATIONS_DELETE_ALL = gql`
  mutation notificationsDeleteAll {
    notificationsDeleteAll
  }
`;
